import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import image from "../../assets/image.png";
import { LOCAL_STORAGE_NAME, PROFIL_USER } from "../../services/config";
import { addItem } from "../../services/LocalStorage";
import AuthContext from "../Context/AuthContext";
import notifyContext from "../Context/notifyContext";
import Loader from "../Loader/Loader";
import { getTokenData, login } from "../../services/Auth__Service";

const Login = () => {
  const notify = useContext(notifyContext);
  const { isAuthentificated, setIsAuthentificated } = useContext(AuthContext);
  const redirect = useNavigate();
  const [error, setError] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [user, setUser] = useState({
    id: 0,
    login: "",
    password: "",
    type: 0,
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    let display_errors = [];

    if (user.login === "") {
      display_errors.push({
        message: "Veuillez entrer votre nom d'utilisateur",
        id_input: "login",
      });
    }
    if (user.password === "") {
      display_errors.push({
        message: "Veuillez entrer votre mot de passe",
        id_input: "password",
      });
    }

    display_errors.map(({ message, id_input }, key) => {
      return (
        <label key={key} htmlFor={id_input}>
          {message}
        </label>
      );
    });

    setError(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0) {
      setIsSend(true);
      login(user)
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          addItem(LOCAL_STORAGE_NAME, data.token);
          setIsAuthentificated(true);
          setIsSend(false);
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Nom d'utilisateur ou Mot de passe incorrect", "error");
          }
          setError("Nom d'utilisateur ou Mot de passe incorrect");
        });
    }
  };

  const handleChange = (e) => {
    setUser((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value.trim(),
      };
    });
  };

  useEffect(() => {
    if (isAuthentificated) {
      const data = getTokenData();
      for (let index = 0; index < PROFIL_USER.length; index++) {
        const element = PROFIL_USER[index];
        if (parseInt(data.profil) === parseInt(element.profil))
          redirect(element.link);
      }
    }
  }, [isAuthentificated]);
  useEffect(() => {
    if (error) {
      document.querySelector("form .error").scrollIntoView();
    }
  }, [error]);
  return (
    <Fragment>
      <div className="login">
        <div className="login__content">
          <div className="login__left">
            <img src={image} alt="image" />
          </div>
          <div className="login__right">
            <p className="login__title">Bienvenue ...</p>
            <p className="login__instruction">Connectez-vous à votre compte.</p>

            <form className="form" onSubmit={handleSubmit}>
              <div className="form-header">
                <div className="error">{error}</div>
              </div>

              <div className="form-body">
                <div className="form-group">
                  <label htmlFor="login" className="form-label">
                    Nom d'utilisateur :
                  </label>
                  <input
                    type="text"
                    name="login"
                    id="login"
                    className="form-input"
                    value={user.login}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password" className="form-label">
                    Mot de passe :
                  </label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    className="form-input"
                    value={user.password}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-footer">
                <button type="submit" className="btn">
                  Connexion
                </button>
                <p>
                  Mot de passe oublié ?{" "}
                  <Link to="/forgotpassword">Cliquez ici</Link>{" "}
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
      {isSend && <Loader loadingMsg="Connexion en cours..." />}
    </Fragment>
  );
};

export default Login;
